import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Text, Box, Select } from 'core/components';

const IP_OPTIONS = [
  { value: 'v4', label: 'IPv4' },
  { value: 'v6', label: 'IPv6' }
];

function valueRenderer(option) {
  return (
    <Box>
      <Text as="div" fontSize="small" color="muted" pb="1px">
        IP Address Family
      </Text>
      <Text as="div" fontWeight="bold" fontSize="small">
        {option?.label}
      </Text>
    </Box>
  );
}

@observer
class IpFilter extends Component {
  render() {
    const { onChange, defaultFilter, disabled, ...rest } = this.props;
    const { ip } = defaultFilter;

    return (
      <Box {...rest}>
        <Select
          options={IP_OPTIONS}
          values={ip}
          valueRenderer={valueRenderer}
          onChange={(option) => onChange({ ip: option })}
          menuWidth={160}
          disabled={disabled}
        />
      </Box>
    );
  }
}

export default IpFilter;
